import React from "react";
import "./Footer.scss";

// Components
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";

// Libraries & Packages
import { Link } from "react-router-dom";

// Utils
import Navigation from "utils/navigation/Navigation";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__section01">
        <div className="footer__section01__name">
          <AnimatedText>Naveen Liyanage</AnimatedText>
        </div>
        <div className="footer__section01__trademark">
          <AnimatedText>
            © 2024 Naveen Liyanage. All Rights Reserved
          </AnimatedText>
        </div>
      </div>
      <div className="footer__section02">
        <div className="footer__section02__list">
          <div className="footer__section02__list__heading">
            <AnimatedText>Explore</AnimatedText>
          </div>
          <div className="footer__section02__list__items">
            {Navigation.globalNavigation
              .filter((item) => item.type === "explore")
              .map((item, i) => {
                return (
                  <div className="footer__section02__list__item" key={i}>
                    <Link to={item.link} style={{ textDecoration: "none" }}>
                      <AnimatedText>{item.name}</AnimatedText>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="footer__section02__list">
          <div className="footer__section02__list__heading">
            <AnimatedText>Services</AnimatedText>
          </div>
          <div className="footer__section02__list__items">
            {Navigation.globalNavigation
              .filter((item) => item.type === "services")
              .map((item, i) => {
                return (
                  <div className="footer__section02__list__item" key={i}>
                    <Link to={item.link} style={{ textDecoration: "none" }}>
                      <AnimatedText>{item.name}</AnimatedText>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
